import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSmsAuditList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/sms-logs', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserType() {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/sms-logs-user-types')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTriggers() {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/sms-logs-triggers')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
